// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create-budget-container .txt{font-size:14px;margin-bottom:10px;margin-top:20px;color:#51606d}.create-budget-container .buttons{display:flex;flex-direction:row-reverse;margin-top:60px;margin-bottom:50px}.create-budget-container .buttons #btn-create-budget{margin-left:15px}.create-budget-container .checkbox-container{margin-top:16px;margin-bottom:0}.create-budget-container .checkbox-container .txt{margin-top:0;margin-bottom:0}\n", ""]);
// Exports
module.exports = exports;
